export class removeItemMenu {
    data: any;
    action: string;
    constructor (data,action) {
        this.data = data;
        this.action = action;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/left-menu/remove-item-menu.ts